import axiosInstance from "../axios/axiosInstance";
import AuthorizationService from "./AuthorizationService";
import config from "./Config";
import RoleService from "./RoleService";

export default class UsuarioService {

    async listAllUsers(iss) {
        const accessLevel = AuthorizationService.getResourceAccessLevel('usuario');
        const idUser = RoleService.getUser();

        switch (accessLevel) {
            case 'GLOBAL':
                return this.listAllUser(iss);
            case 'COMPANY':
                return this.listAllUser(iss);
            case 'SELF':
                return this.getUser(iss, idUser);
            default:
                throw new Error('Acesso não autorizado');
        }
    }

    getMe(data) {
        return axiosInstance.get(`${config.api.version}/auth/${data}/me`)
    }

    listAllUser(data) {
        return axiosInstance.get(`${config.api.version}/user/${data}/get`)
    }

    getUser(data, id) {
        return axiosInstance.get(`${config.api.version}/user/${data}/get/${id}`)
    }

    getUserFilter(data, search) {
        var params = { all: true }
        return axiosInstance.get(`${config.api.version}/user/${data}/get?${search}`, {
            params: params
        })
    }

    postUser(data, user) {
        return axiosInstance.post(`${config.api.version}/user/${data}/`, user)
    }

    putUser(data, user, id) {
        return axiosInstance.put(`${config.api.version}/user/${data}/${id}`, user)
    }

    deleteUser(data, id) {
        return axiosInstance.put(`${config.api.version}/user/${data}/delete/${id}`)
    }

    activeUser(data, id, status) {
        return axiosInstance.put(`${config.api.version}/user/${data}/active/${id}/${status}`)
    }

    changeRoleUser(data, user, id) {
        return axiosInstance.put(`${config.api.version}/user/${data}/role/${id}`, user)
    }

    getUserLocalData() {
        return JSON.parse(localStorage.getItem('idUser'));
    }

    getEmpresaLocalData() {
        return JSON.parse(localStorage.getItem('idEmpresa'));
    }

    getPrestadorLocalData() {
        return JSON.parse(localStorage.getItem('idPrestador'));
    }

}
